var path = '/templates/zenclerk_s/directives/estimated_revenue/estimated_revenue.html';
var html = "<span class=campaign-estimated-revenue ng-if=\"vm.revenue >= vm.limit\">{{vm.revenue || 0 | zcCurrency:vm.currency.symbol:0:vm.currency.suffix}}</span> <span class=campaign-estimated-revenue ng-if=\"!vm.revenue || vm.revenue < vm.limit\" uib-tooltip=\"{{ 'directives.estimatedRevenue.noEnoughDataToPredictOrEmailIsForEmailNewsletterDelivery' | translate }}\"><small class=no-data-text>{{ 'directives.estimatedRevenue.cannotPredict' | translate }} <span class=\"badge badge-tooltip\"><i class=\"fa fa-question\"></i></span></small></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/estimated_revenue/estimated_revenue.html
// module id = 1341
// module chunks = 0